import { Toast, Modal } from 'antd-mobile';
import { parse } from 'qs';
import { check } from '@/services/saas/watchAuthority';
import { checkAuthority } from '@/services/saas/user';

const prompt = Modal.prompt;

export function getPageQuery() {
  return parse(window.location.href.split('?')[1]);
}

export function setToken(token) {
  localStorage.setItem('ts-token', token);
}

export function getToken() {
  return localStorage.getItem('ts-token');
}

export function setTenantInfo(info) {
  return localStorage.setItem('ts-tenant-info', JSON.stringify(info));
}

export function getTenantInfo() {
  return JSON.parse(localStorage.getItem('ts-tenant-info'));
}

export function setUser(userInfo) {
  localStorage.setItem('ts-user', JSON.stringify(userInfo));
}

export function getUser() {
  return JSON.parse(localStorage.getItem('ts-user'));
}

export function setPlatConfig(platformConfig) {
  localStorage.setItem('ts-platform-config', JSON.stringify(platformConfig));
}

export function getPlatConfig() {
  return JSON.parse(localStorage.getItem('ts-platform-config'));
}

export function setParamBiz(bizParam) {
  localStorage.setItem('ts-param-biz', JSON.stringify(bizParam));
}

export function getParamBiz() {
  return JSON.parse(localStorage.getItem('ts-param-biz'));
}

export function setApp(sourceApp) {
  localStorage.setItem('ts-app', JSON.stringify(sourceApp));
}

export function getApp() {
  return JSON.parse(localStorage.getItem('ts-app'));
}

export function setStudioHistory(histories) {
  localStorage.setItem('studioName-search-history', JSON.stringify(histories));
}

export function getStudioHistory() {
  return JSON.parse(localStorage.getItem('studioName-search-history'));
}

export function removeAll() {
  localStorage.removeItem('ts-user');
  localStorage.removeItem('ts-token');
  localStorage.removeItem('ts-platform-config');
  localStorage.removeItem('ts-param-biz');
  localStorage.removeItem('ts-app');
  localStorage.removeItem('studioName-search-history');
  // localStorage.removeItem('ts-tenant-info');
}

function postMessage(param) {
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.jsToNativeWithParams &&
    window.webkit.messageHandlers.jsToNativeWithParams.postMessage
  ) {
    window.webkit.messageHandlers.jsToNativeWithParams.postMessage(param);
  }
}

export function logout() {
  const { third_login_address_h5 } = getParamBiz() || {};
  removeAll();
  if (third_login_address_h5) {
    window.open(third_login_address_h5, '_self');
    return;
  }
  if (window.AndroidWebView && window.AndroidWebView.toBack) {
    window.AndroidWebView.toBack();
    return;
  }
  postMessage({
    method: 'logout',
  });
  if (window.location.href.indexOf('/apps/login') === -1) window.location.href = '/apps/login';
}

export function getBooleanValue(key, defaultValue, callback) {
  if (window.AndroidWebView && window.AndroidWebView.getBooleanValue) {
    defaultValue = window.AndroidWebView.getBooleanValue(key, defaultValue);
  } else {
    window[`setBoolean${key}`] = (json) => {
      const value = JSON.parse(json)[key];
      if (callback) {
        console.log(`callback--Boolean--${value}`);
        callback(value);
      }
    };
    postMessage({
      method: 'properties',
      params: {
        names: [key],
        callback: `setBoolean${key}`,
      },
    });
  }
  return defaultValue;
}

export function putBooleanValue(key, value) {
  if (window.AndroidWebView && window.AndroidWebView.putBooleanValue) {
    window.AndroidWebView.putBooleanValue(key, value);
  }
  postMessage({
    method: 'media',
    params: {
      [key]: value ? 1 : 0,
    },
  });
}

export function getStringValue(key, defaultValue, callback) {
  if (window.AndroidWebView && window.AndroidWebView.getStringValue) {
    defaultValue = window.AndroidWebView.getStringValue(key, defaultValue);
  } else {
    window[`setString${key}`] = (json) => {
      const value = JSON.parse(json)[key];
      if (callback) {
        console.log(`callback--String--${value}`);
        callback(value);
      }
    };
    postMessage({
      method: 'properties',
      params: {
        names: [key],
        callback: `setString${key}`,
      },
    });
  }
  return defaultValue;
}

export function toConference(config) {
  console.log(config);
  if (window.AndroidWebView && window.AndroidWebView.toConference) {
    window.AndroidWebView.toConference(JSON.stringify(config));
  }
  postMessage({
    method: 'join',
    params: {
      addr:
        config.base && config.base.cloudWebRtcSocketUrL
          ? config.base.cloudWebRtcSocketUrL.replace('ws', 'http')
          : '',
      room:
        config.conferenceInfo && config.conferenceInfo.conferenceCode
          ? config.conferenceInfo.conferenceCode
          : '',
      username: config.userInfo && config.userInfo.userName ? config.userInfo.userName : '',
      confpass:
        config.conferenceInfo && config.conferenceInfo ? config.conferenceInfo.password : '',
      conferenceId:
        config.conferenceInfo && config.conferenceInfo ? config.conferenceInfo.conferenceId : '',
      conferenceName:
        config.conferenceInfo && config.conferenceInfo ? config.conferenceInfo.conferenceName : '',
    },
  });
}

export function getDefaultCover() {
  return {
    app: require('../images/pic_default_app.png'),
    live: require('../images/pic_default_live.png'),
    res: require('../images/pic_default_res.png'),
    teacher: require('../images/ico_user_avator.png'),
    school: require('../images/pic_default_school.png'),
    famousSchool: require('../images/pic_default_famous_school.png'),
  };
}

export function getSiteIp() {
  let siteIp = window.location.hostname;
  // siteIp = '10.1.38.11';
  return siteIp;
}

export function getWeek(date) {
  const week = date.day();
  switch (week) {
    case 1:
      return '周一';
    case 2:
      return '周二';
    case 3:
      return '周三';
    case 4:
      return '周四';
    case 5:
      return '周五';
    case 6:
      return '周六';
    case 0:
      return '周日';
    default:
      return '';
  }
}

export async function checkPermition(id, bizType, pwd, callback) {
  const parms = { bizId: id, bizType };
  if (pwd) {
    parms.pwd = pwd;
  }
  const respwatchAuthority = await check(parms);
  if (respwatchAuthority.success) {
    if (respwatchAuthority.data === false) {
      Toast.info('你没有权限观看该资源');
      return;
    }
    if (respwatchAuthority.data === 'errorPwd') {
      Toast.info(respwatchAuthority.msg, 3, () => {
        prompt(
          '请输入密码',
          '输入密码可观看',
          (password) => {
            if (password) {
              checkPermition(id, bizType, password, callback);
            }
          },
          'secure-text',
        );
      });
    }
    if (respwatchAuthority.data === 'requirePwd') {
      prompt(
        '请输入密码',
        '输入密码可观看',
        (password) => {
          if (password) {
            checkPermition(id, bizType, password, callback);
          }
        },
        'secure-text',
      );
    }
    if (respwatchAuthority.data === 'requireLogin') {
      Toast.info(respwatchAuthority.msg, 3, () => {
        logout();
      });
    }
    if (respwatchAuthority.data === 'unknownError') {
      Toast.info.warn(respwatchAuthority.msg);
      return;
    }
    if (respwatchAuthority.data === true) {
      if (callback) {
        callback();
      }
    }
  }
}

export async function checkLogin({ onLogin, onCancel }) {
  let isLogin = false;
  const token = getToken();
  const { third_login_address_h5 } = getParamBiz() || {};
  if (token) {
    const isAuth = await checkAuthority({ token });
    isLogin = isAuth.success && isAuth.data;
  }
  if (!isLogin) {
    Modal.alert('是否登录', '检测到您未登录或登录已失效', [
      { text: '取消', onPress: onCancel },
      {
        text: '确定',
        onPress: third_login_address_h5
          ? () => {
              window.open(third_login_address_h5, '_self');
            }
          : logout,
      },
    ]);
  } else {
    onLogin && onLogin();
  }
}

export function initWs(websocketUrl, onPlay = () => {}) {
  let wsIns;
  if (window.WebSocket && websocketUrl) {
    try {
      wsIns = new window.WebSocket(websocketUrl);
      wsIns.onopen = () => {
        onPlay(true);
      };
      wsIns.onerror = () => {
        onPlay(false);
      };
    } catch (err) {
      onPlay(false);
      console.log(err);
    }
  } else {
    onPlay(false);
  }
  return wsIns;
}

export function isMobile() {
  return !!navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
  );
}
